import type { ChatTranscript } from '@/pocs/chat/export/types'

const MAX_TITLE_LENGTH = 60
const INVALID_FILE_NAME_CHARACTERS = /[\\/:*?"<>|\r\n\t]+/g

export function sanitizeFileName(name: string) {
  return name
    .replace(INVALID_FILE_NAME_CHARACTERS, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

function toLocalDate(date: Date) {
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export function getDefaultExportFileName(
  prefix: string,
  { title, exportedAt }: ChatTranscript,
) {
  const shortTitle = sanitizeFileName(title).slice(0, MAX_TITLE_LENGTH).trim()
  return [prefix, shortTitle, toLocalDate(exportedAt)]
    .filter(Boolean)
    .join(' - ')
}
